import { render, staticRenderFns } from "./TopFront.vue?vue&type=template&id=51a21c91&scoped=true"
import script from "./TopFront.vue?vue&type=script&lang=js"
export * from "./TopFront.vue?vue&type=script&lang=js"
import style0 from "./TopFront.vue?vue&type=style&index=0&id=51a21c91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a21c91",
  null
  
)

export default component.exports